import { render, staticRenderFns } from "./ChipButton.vue?vue&type=template&id=5a15e41f&"
import script from "./ChipButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChipButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ChipButton.vue?vue&type=style&index=0&id=5a15e41f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports